<template>
  <v-app>
    <v-navigation-drawer
      persistent
      temporary
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
    <v-jumbotron
    :gradient="gradient"
    height="200"
    src="/static/background/abstract-glass.jpeg"
  >
    <v-container fill-height>
      <v-layout align-center>
        <v-flex text-xs-center>
         <v-avatar size="100" color="teal">
          <img src="/static/perfils/wesley.jpeg" alt="wesley">
        </v-avatar>
            <br><span><h1>Wesley Hott Soares</h1></span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>
    <v-card>
      <v-card-actions>
          <v-btn flat>wesley.hott@gmail.com</v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="show = !show">
            <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-slide-y-transition>
          <v-card-text v-show="show">
            Este aplicativo está em desenvolvimento e optei por não restringir por senha nesse momento. Caso tenha alguma questão, fique à vontade por enviar mensagem por e-mail.
          </v-card-text>
        </v-slide-y-transition>
    </v-card>
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      :clipped-left="clipped"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span> &nbsp;&copy; 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      gradient: 'to top right, rgba(0,137,123, .4), rgba(0,77,64, .8)',
      show: false,
      clipped: false,
      drawer: false,
      fixed: false,
      items: [{
        icon: 'person',
        title: 'Perfil'
      }],
      title: ''
    }
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue